import { useRef, useState } from "react";
import { CharacterAvatar } from "../components/CharacterAvatar.js";
import { ImageCropModal } from "../components/ImageCropModal.js";
import { Icon } from "../components/Icon.js";
import { useToast } from "../components/Toast.js";

const ACCEPT = "image/jpeg,image/png,image/webp";

/** Portrait + upload/replace/remove controls for the character editor. Delegates
 * storage to the caller's onChange (a data URL, or null to clear). */
export function PortraitControl({
  name,
  imageUrl,
  onChange
}: {
  name: string;
  imageUrl?: string | null;
  onChange: (dataUrl: string | null) => void | Promise<void>;
}) {
  const toast = useToast();
  const inputRef = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<File | null>(null);

  const pick = (f: File | null) => {
    if (!f) return;
    if (!/^image\/(jpeg|png|webp)$/.test(f.type)) { toast.error("Use a JPG, PNG, or WebP image."); return; }
    setFile(f);
  };

  return (
    <div className="portrait-control">
      <CharacterAvatar name={name || "?"} imageUrl={imageUrl} size="lg" ring />
      <div className="portrait-actions">
        <button className="btn btn-sm btn-ghost" onClick={() => inputRef.current?.click()}>
          <Icon name="image" size={13} /> {imageUrl ? "Change" : "Add image"}
        </button>
        {imageUrl && (
          <button className="btn btn-sm btn-ghost btn-danger" onClick={() => void onChange(null)}>
            <Icon name="trash" size={13} /> Remove
          </button>
        )}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPT}
        style={{ display: "none" }}
        onChange={(e) => { pick(e.target.files?.[0] ?? null); e.target.value = ""; }}
      />
      {file && (
        <ImageCropModal
          file={file}
          name={name || "Character"}
          onClose={() => setFile(null)}
          onSave={(d) => { setFile(null); void onChange(d); }}
        />
      )}
    </div>
  );
}
